module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_rectangular_marco_comida_28.a4e08a49.png";